"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_2 = require("@angular/core");
var core_3 = require("@angular/core");
var dynamic_component_service_1 = require("./service/dynamic-component.service");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
/**
 * Component for dynamically loading other component by selector-component-module.
 * NOTE: Component has to be added to the entry components of it's module to be dynamically created.
 */
var DynamicComponentLoaderComponent = /** @class */ (function () {
    function DynamicComponentLoaderComponent(dynamicComponentService) {
        this.dynamicComponentService = dynamicComponentService;
        this._destroy$ = new Subject_1.Subject();
    }
    DynamicComponentLoaderComponent.prototype.ngOnChanges = function (changes) {
        if (changes.componentSelector) {
            this.renderComponentInstance();
        }
        else if (changes.componentInputs) {
            this.setComponentInputs();
        }
    };
    DynamicComponentLoaderComponent.prototype.renderComponentInstance = function () {
        var _this = this;
        this.destroyComponentInstance();
        this.dynamicComponentService.getComponentBySelector(this.component, this.componentSelector, this.moduleLoaderFunction)
            .pipe(operators_1.take(1), operators_1.takeUntil(this._destroy$))
            .subscribe(function (createdComponent) {
            _this._createdComponent = createdComponent;
            _this.createdComponentContainer.insert(_this._createdComponent.hostView);
            _this.setComponentInputs();
        });
    };
    DynamicComponentLoaderComponent.prototype.setComponentInputs = function () {
        var _this = this;
        if (this._createdComponent && this._createdComponent.instance && this.componentInputs) {
            Object.keys(this.componentInputs).forEach(function (prop) {
                return (_this._createdComponent.instance[prop] = _this.componentInputs[prop]);
            });
        }
    };
    DynamicComponentLoaderComponent.prototype.destroyComponentInstance = function () {
        this.dynamicComponentService.destroyComponents();
        this._createdComponent = null;
    };
    DynamicComponentLoaderComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
        this.destroyComponentInstance();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicComponentLoaderComponent.prototype, "componentSelector", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicComponentLoaderComponent.prototype, "component", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], DynamicComponentLoaderComponent.prototype, "moduleLoaderFunction", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicComponentLoaderComponent.prototype, "componentInputs", void 0);
    __decorate([
        core_2.ViewChild('createdComponentContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.ViewContainerRef)
    ], DynamicComponentLoaderComponent.prototype, "createdComponentContainer", void 0);
    DynamicComponentLoaderComponent = __decorate([
        core_3.Component({
            selector: 'ejustice-dynamic-component-loader',
            template: "\n        <ng-container #createdComponentContainer></ng-container>\n    "
        }),
        __metadata("design:paramtypes", [dynamic_component_service_1.DynamicComponentService])
    ], DynamicComponentLoaderComponent);
    return DynamicComponentLoaderComponent;
}());
exports.DynamicComponentLoaderComponent = DynamicComponentLoaderComponent;
//# sourceMappingURL=dynamic-component-loader.component.js.map